"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PrimarySummary;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _CharacterStatsWindowModule = _interopRequireDefault(require("../../CharacterStatsWindow.module.scss"));

var _CharacterStatsWindow = _interopRequireDefault(require("../../CharacterStatsWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrimarySummary(_ref) {
  var name = _ref.name,
      nationI18nName = _ref.nationI18nName,
      guildName = _ref.guildName,
      rank = _ref.rank,
      reputation = _ref.reputation,
      characterClassI18nName = _ref.characterClassI18nName,
      level = _ref.level,
      experience = _ref.experience,
      experienceMax = _ref.experienceMax;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _CharacterStatsWindowModule.default.primarySummary
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.name, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.name, " ").concat(_CharacterStatsWindowModule.default.value)
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.nation, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.nation)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.nation, " ").concat(_CharacterStatsWindowModule.default.value)
  }, nationI18nName), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.guild, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.guild)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.guild, " ").concat(_CharacterStatsWindowModule.default.value)
  }, guildName), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.rank, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.rank)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.rank, " ").concat(_CharacterStatsWindowModule.default.value)
  }, rank), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.repute, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.repute)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.repute, " ").concat(_CharacterStatsWindowModule.default.value)
  }, reputation), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.class, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.class)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.class, " ").concat(_CharacterStatsWindowModule.default.value)
  }, characterClassI18nName), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.level, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.level)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.level, " ").concat(_CharacterStatsWindowModule.default.value)
  }, level), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.exp, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.exp)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.exp, " ").concat(_CharacterStatsWindowModule.default.value)
  }, experience, " / ", experienceMax));
}